module.exports = __webpack_public_path__ + "img/support.c1049364.svg";